export default {
  controls: [],
  solutions: [
    {
      title: 'Complex solution',
      style: 'thumbnails',
      image: 'COMPLEX_SOLUTION.jpg',
      explanation: 'complex_solution'
    },
    {
      title: 'Tool trolley',
      style: 'thumbnails',
      image: 'TOOL_TROLLEY.jpg',
      explanation: 'tool_trolley'
    }
  ],
  keyFeatures: [
		{
      title: 'key_features.easy_of_operation',
      style: 'thumbnails',
      image: 'EASY_OF_OPERATION.jpg',
      explanation: 'easy_of_operation',
    },
		{
      title: 'key_features.positioning',
      style: 'thumbnails',
      image: 'POSITIONING.jpg',
      explanation: 'positioning',
    },
		{
      title: 'key_features.accesories',
      style: 'thumbnails',
      image: 'ACCESORIES.jpg',
      explanation: 'accesories',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'COMFORT.jpg',
      explanation: 'comfort',
    }
	],
  modifications: [
		{
      title: 'Accessories',
      icon: 'icon-accessories',
      options: {
        style: 'thumbnails',
        default: 1,
        items: [
          {
            title: 'modifications.accessories.stool_and_trolley',
            image: 'TOOL_TROLLEY.jpg',
            modelParts: [
              { name: 'stolek_loc', visible: true },
              { name: 'gracieZidle_grp', visible: true },
            ]
          },
          {
            title: 'modifications.accessories.none',
            image: 'NO_EXTRAS.jpg',
            modelParts: [
              { name: 'stolek_loc', visible: false },
              { name: 'gracieZidle_grp', visible: false },
            ]
          }
        ]
      }
    },
		{
      title: 'Colour design',
      icon: 'icon-colors',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
					{
            title: 'Corn Yellow',
            image: 'colors/Yellow.jpg',
            color: 'yellow'
          },
					{
            title: 'Orange',
            image: 'colors/Orange.jpg',
            color: 'orange'
          },
          {
            title: 'Brilliant Blue',
            image: 'colors/Blue.jpg',
            color: 'blue'
          },
					{
            title: 'Ocean Green',
            image: 'colors/Green.jpg',
            color: 'green'
          },
          {
            title: 'Lavender',
            image: 'colors/Lavender.jpg',
            color: 'lavender'
          }
        ]
      }
    }
	]
}